import { useState, useEffect } from "react";

// Custom Hook: Must start with "use"
export const useDeviceIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isMobile;
};

export const useDeviceIsTabletAndMobile = () => {
  const [istTabletAndMobile, setIsTabletAndMobile] = useState(
    window.innerWidth < 1024
  );

  useEffect(() => {
    const handleResize = () => {
      setIsTabletAndMobile(window.innerWidth < 1024);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return istTabletAndMobile;
};

export const useDeviceIsLaptopSmToMobile = () => {
  const [isLaptopSmToMobile, setIsLaptopSmToMobile] = useState(
    window.innerWidth < 1280
  );

  useEffect(() => {
    const handleResize = () => {
      setIsLaptopSmToMobile(window.innerWidth < 1280);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isLaptopSmToMobile;
};


export const usePagination = (items, itemsPerPage) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);

  const totalItems = Math.ceil(items.length / itemsPerPage);
  const currentItems = items.slice(currentIndex, currentIndex + itemsPerPage);

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prevIndex) => {
        const newIndex = Math.max(prevIndex - itemsPerPage, 0);
        setCurrentSlide(newIndex / itemsPerPage);
        return newIndex;
      });
    }
  };

  const handleNext = () => {
    if (currentIndex + itemsPerPage < items.length) {
      setCurrentIndex((prevIndex) => {
        const newIndex = prevIndex + itemsPerPage;
        setCurrentSlide(newIndex / itemsPerPage);
        return newIndex;
      });
    }
  };

  const setCurrentPage = (index) => {
    setCurrentSlide(index);
    setCurrentIndex(index * itemsPerPage);
  };

  return {
    currentIndex,
    currentSlide,
    currentItems,
    totalItems,
    handlePrevious,
    handleNext,
    setCurrentPage,
  };
};
